// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"Slider_swiperContainer__CADKv","swiperWrapper":"Slider_swiperWrapper__sU7A7","swiperPagination":"Slider_swiperPagination__39j5V"};